import { LoadingButton } from "../../components/ui/Button";
import ImageUploader from "../../components/ui/ImageUploader";;
import useUpdateProfile from "../../services/profile/useUpdateProfile";
import { useApplication } from "../../context/app";
import { onMount } from "solid-js";
import { RadioGroupInput } from "../../components/ui/form/RadioGroupInput";
import { SelectInput } from "../../components/ui/form/SelectInput";
import { TextInput } from "../../components/ui/form/TextInput";
import { DateInput } from "../../components/ui/form/DateInput";
import {
  Card,
  CardContent,
  CardHeader,
  CardDescription,
  CardTitle
} from "@/components/shadcn/card";

export default function Profile() {

  const { setBreadcrumb } = useApplication();

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Profile',
        current: true
      }
    ]);
  });

  const { 
    form,
    handleInput,
    titleOptions,
    handleChange,
    handleProfileUpdate,
    handlePhotoChange,
    loading
  } = useUpdateProfile();

  const genderOptions = [
    { value: 'Male', text: 'Male', disabled: true },
    { value: 'Female', text: 'Female', disabled: true },
    { value: 'Other', text: 'Other', disabled: true }
  ];

  return (
    <div className="main-card">
      <form autocomplete="off">
        <div class="grid grid-cols-12 gap-2">
          <Card class="lg:col-span-3 sm:col-span-6 col-span-12">
            <CardHeader class="pb-2">
              <CardTitle>Change Photo</CardTitle>
              <CardDescription class="text-sm">Photo should be at least 100px x 100px</CardDescription>
            </CardHeader>
            <CardContent>
              <ImageUploader
                onPhotoChanged={handlePhotoChange}
                placeholder={form.photoURL}
                width="128px"
                height="128px"
                uploadBtnText=""
                resetBtnText=""
              />
            </CardContent>
          </Card>
          <Card class="lg:col-span-4 sm:col-span-6 col-span-12">
            <CardHeader>
              <CardTitle>Account Information</CardTitle>
            </CardHeader>
            <CardContent>
              <div class="form-group">
                <TextInput
                  label="Email"
                  name="email"
                  form={form}
                  readOnly
                />
              </div>
              <div class="form-group">
                <TextInput
                  label="Username"
                  name="username"
                  form={form}
                  readOnly
                />
              </div>
              <div class="form-group">
                <TextInput
                  label="Role"
                  name="roleName"
                  form={form}
                  readOnly
                />
              </div>
            </CardContent>
          </Card>
          <Card class="lg:col-span-5 col-span-12">
            <CardHeader>
              <CardTitle>Basic Information</CardTitle>
            </CardHeader>
            <CardContent>
              <div class="grid grid-cols-4 gap-1">
                <div class="form-group col-span-2">
                  <TextInput
                    label="Full Name"
                    name="name"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-2">
                  <TextInput
                    label="Short Name"
                    name="shortName"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-3 mb-2">
                  <RadioGroupInput
                    name="gender"
                    label="Gender"
                    input={handleChange}
                    form={form}
                    options={genderOptions} />
                </div>
                <div class="form-group col-span-2">
                  <SelectInput
                    name="title"
                    label="Title"
                    input={handleChange}
                    form={form}
                    options={titleOptions()} />
                </div>
                <div class="form-group col-span-2">
                  <DateInput
                    label="Date of Birth"
                    name="birthDate"
                    form={form}
                    input={handleChange}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div class="text-end mt-3">
          <LoadingButton loading={loading()} onClick={handleProfileUpdate}>Save</LoadingButton>
        </div>
      </form>
    </div>
  );
}
